<template lang="pug">
.icon-check
  svg(xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44")
    circle(cx="22" cy="22" :r="22*t1" fill="#1677FF")
    circle(cx="22" cy="22" :r="22*t2" fill="#FFFFFF")
    circle(cx="22" cy="22" :r="22*t3" fill="#1677FF")
    path(d="M18.98 25.79l-5.35-5.35-2.14 2.14 7.49 7.49 2.14-2.14L33.23 15.8l-2.14-2.14-12.12 12.12z" fill="#ffffff" fill-rule="nonzero")
    //path(d="M22 .83a21.17 21.17 0 110 42.34A21.17 21.17 0 0122 .83z" fill="#ffffff")

  
</template>
<script>
import gsap from 'gsap'
export default {
  name: 'IconCheck',
  props: {
    auto: {
      default: false,
    },
  },
  data() {
    return {
      t1: 0,
      t2: 0,
      t3: 0,
    }
  },
  computed: {},
  methods: {
    animeIn() {
      gsap
        .timeline()
        .to(this, { t1: 1, duration: 0.2, ease: 'power3.out' })
        .to(this, { t2: 1, duration: 0.2, ease: 'power3.out' }, 0.1)
        .to(this, { t3: 1, duration: 0.2, ease: 'power3.out' }, 0.2)
    },
    animeOut() {
      gsap.to(this, { t1: 0, t2: 0, t3: 0, duration: 0.2, ease: 'power3.out' })
    },
  },
  mounted() {
    if (this.auto) {
      setTimeout(() => {
        this.animeIn()
      }, 200)
    }
  },
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.icon-check
  line-height: 0
  width: 100%
  height: 100%
  svg
    width: 100%
    height: 100%
</style>
